import errorMessages from 'plugins/i18n/errorMessages.de.ts'

export default {
	error: {
		errorMessages: errorMessages,
		insufficientPermission:
			'Sie verfügen leider nicht über die erforderliche Berechtigung um fortzufahren',
		pageNotFound: 'Die angeforderte Seite wurde nicht gefunden',
		unexpectedError: 'Entschuldigen Sie bitte, es ist ein Fehler aufgetreten',
	},
}
